import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Grid, H, Image, P, Wrapper } from '@farewill/ui'
import { screenMax } from '@farewill/ui/helpers/responsive'
import { FUNERAL } from 'lib/products/constants'
import { CTA_TYPES } from 'components/Cta/constants'
import Cta from 'components/Cta'
import Cards from './Cards'

const StyledTexture = styled.div`
  position: absolute;
  top: -160px;
  right: 0;

  ${screenMax.m`
    display: none;
  `}
`

const StyledWrapper = styled(Wrapper)`
  position: relative;
`

const WhatWeOffer = ({ phoneNumber }) => (
  <StyledWrapper margin={['L', 0]}>
    <StyledTexture>
      <Image path="textures/blob-2-yellow" width={180} widthFromXL={240} />
    </StyledTexture>
    <Grid container>
      <Grid.Item
        spanFromM={10}
        startColumnFromM={2}
        spanFromL={9}
        startColumnFromL={1}
        spanFromXL={12}
      >
        <H decorative size="L">
          Direct cremation. <br /> It’s a funeral done your way.
        </H>
      </Grid.Item>
      <Grid.Item
        span={12}
        spanFromM={10}
        startColumnFromM={2}
        spanFromL={10}
        startColumnFromL={1}
        spanFromXL={8}
      >
        <P size="L">
          Direct cremation is simply a cremation without a funeral service. It’s
          fast becoming the choice of families who want to choose how and where
          they say goodbye to their loved one, at a time that’s right for them.
        </P>
      </Grid.Item>
      <Grid.Item
        spanFromM={10}
        startColumnFromM={2}
        spanFromL={12}
        startColumnFromL="auto"
      >
        <Cta
          type={CTA_TYPES.TELEPHONE_NUMBER}
          text="Call us now for a quote"
          telephoneNumber={phoneNumber}
          useSwappedNumber={false}
          product={FUNERAL}
        />
      </Grid.Item>
      <Grid.Item>
        <Cards />
      </Grid.Item>
    </Grid>
  </StyledWrapper>
)

WhatWeOffer.propTypes = {
  phoneNumber: PropTypes.string,
}

WhatWeOffer.defaultProps = {
  phoneNumber: null,
}

export default WhatWeOffer
